import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=77c5623a&scoped=true"
import script from "./AboutCard.vue?vue&type=script&lang=js"
export * from "./AboutCard.vue?vue&type=script&lang=js"
import style0 from "./AboutCard.vue?vue&type=style&index=0&id=77c5623a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5623a",
  null
  
)

export default component.exports